import * as at from './grid_action_types';

export function memorizeColumnWidths(stateId, memorizedColumnWidths) {
  return (dispatch) =>
    dispatch({
      type: at.MEMORIZE_COLUMN_WIDTHS,
      payload: memorizedColumnWidths,
      stateId,
    });
}
